import { render, staticRenderFns } from "./ShowPersonalInfo.vue?vue&type=template&id=41805cac&"
import script from "./ShowPersonalInfo.vue?vue&type=script&lang=ts&"
export * from "./ShowPersonalInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports